import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectPackageCostInfo } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionFortuneTellerEventRequestBuyPackage, TypeActionFortuneTellerEventInfo, } from "../actionFortuneTellerEventInfo";
export var epicFortuneTellerEventBuyPackage = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionFortuneTellerEventInfo.BuyPackage), switchMap(function (action) {
        var state = state$.value;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var packageCost = selectPackageCostInfo(action.packageId);
        var goldRequired = !packageCost || !packageCost[0] ? Long.ZERO : Long.fromValue(packageCost[0].amount);
        var playerGold = playerGoldInfo.amount || Long.ZERO;
        return of(actionBeginBuyWithGoldProcess(playerGold, goldRequired, actionFortuneTellerEventRequestBuyPackage(action.packageId)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/epics/epicFortuneTellerEventBuyPackage.ts
// module id = 1856
// module chunks = 3